import { SVGProps } from 'react'

export const ESIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16816_21977)">
      <path
        d="M0 23.9987C0 26.9344 0.528094 29.7465 1.49278 32.3465L24 34.4334L46.5072 32.3465C47.4719 29.7465 48 26.9344 48 23.9987C48 21.063 47.4719 18.2509 46.5072 15.6509L24 13.564L1.49278 15.6509C0.528094 18.2509 0 21.063 0 23.9987Z"
        fill="#FFDA44"
      />
      <path
        d="M46.5103 15.6517C43.1193 6.51261 34.3222 -0.000488281 24.0031 -0.000488281C13.6839 -0.000488281 4.88688 6.51261 1.49585 15.6517H46.5103Z"
        fill="#D80027"
      />
      <path
        d="M1.4939 32.3481C4.88493 41.4873 13.682 48.0004 24.0011 48.0004C34.3203 48.0004 43.1173 41.4873 46.5083 32.3481H1.4939Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_16816_21977">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
